import React from "react";
import { Grid, Divider, Chip } from "@material-ui/core";
import SkillsTable from "./tables/skillsTable";
import TargetsTable from "./tables/targetsTable";
import Panel from "./panel";
import Graphics from "../graphics";
import { getLocalizedString } from "@icarius-localization/strings";

export const getStatusResultBackgroundColor = (name) => {
    switch (name) {
        case "Fortaleza":
            return { backgroundColor: "green", color: "white" };
        case "Debilidad":
            return { backgroundColor: "red", color: "black" };
        case "Discrepancia":
            return { backgroundColor: "yellow", color: "black" };
        default:
            return {};
    }
}

const Body = ({ color, summaryData, process, handleOpenViewFeedback, level, }) => {

    return (
        <Grid container alignItems="center" style={{ padding: '0px 50px 0px 0px', marginTop: 15, marginBottom: 10 }}>
            {
                summaryData.hasOwnProperty("skills") &&
                (summaryData.skills.transversalSkills.length > 0 || summaryData.skills.specificSkills.length > 0) &&
                <>
                    <Panel title={getLocalizedString("competencies")}>
                        <SkillsTable summaryData={summaryData.skills} />
                    </Panel>
                    <div style={{ width: "100%" }}>
                        <Divider style={{ margin: "5px 0px", background: color }} />
                    </div>
                </>
            }
            {
                summaryData.hasOwnProperty("targets") &&
                (summaryData.targets.organizationalTargets.length > 0 || summaryData.targets.personalTargets.length > 0) &&
                <>
                    <Panel title={getLocalizedString("goals")}>
                        <TargetsTable evaluations={summaryData.evaluations} summaryData={summaryData.targets} />
                    </Panel>
                    <div style={{ width: "100%" }}>
                        <Divider style={{ margin: "5px 0px", background: color }} />
                    </div>
                </>
            }
            {
                Boolean(summaryData.graphData && (summaryData.graphData.objectiveList.length || summaryData.graphData.skillList.length)) &&
                <>
                    <Panel title={getLocalizedString("summaryAndCharts")}>
                        <Graphics
                            isPartialNote={summaryData.isPartialNote}
                            isPendingCalibration={summaryData.isPendingCalibration}
                            graphData={summaryData.graphData}
                            level={level}
                        />
                    </Panel>
                    <div style={{ width: "100%" }}>
                        <Divider style={{ margin: "5px 0px", background: color }} />
                    </div>
                </>
            }
            {
                Boolean(summaryData.feedback) &&
                <>
                    <Panel title={getLocalizedString("feedback")}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, paddingBottom: 20 }}>
                            <Chip
                                label={`${process.processName} - ${getLocalizedString("interviewDate")}: ${summaryData.feedback.modifiedDate} - ${getLocalizedString("deliveredBy")}: ${summaryData.feedback.owner.name}`}
                                onClick={handleOpenViewFeedback}
                            />
                        </div>
                    </Panel>
                    <div style={{ width: "100%" }}>
                        <Divider style={{ margin: "5px 0px", background: color }} />
                    </div>
                </>
            }
        </Grid>
    )
}

export default Body;